import { Component } from "@angular/core";
import { TitleService } from "./shared/service/title.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
})
export class AppComponent {
    constructor(private titleService: TitleService) {
        // subscribe to router events and send page views to Google Analytics

        this.titleService.init();
    }
}
